export default "__VITE_ASSET__BusNYi_1__"